import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { FieldReannotationPanel } from "./FieldReannotationPanel";

export { FieldReannotationParamsForm } from "./FieldReannotationParamsForm";
export { useFieldReannotationParams } from "./useFieldReannotationParams";
export type { UseFieldReannotationParamsResult } from "./useFieldReannotationParams";

export const FIELD_REANNOTATION_VIEW: BatchJobKindView = {
  label: "Field re-annotation",
  Panel: FieldReannotationPanel,
};
